import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from 'app/shared/models/class/user/user';
import { UserAnswer } from 'app/shared/models/class/user/userAnswer';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private httpClient: HttpClient) {}

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getAllUSer(): Observable<User[]> {
    return this.httpClient.get<User[]>(`${environment.apiUrl}users`);
  }

  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */

  resetPassword(userId: string, token: string, newPassword: string) {
    const body = { token, new_password: newPassword };
    return this.httpClient.post(
      `${environment.apiUrl}users/${userId}/password-reset`,
      body
    );
  }

  getAllAnswers(): Observable<UserAnswer[]> {
    return this.httpClient.get<UserAnswer[]>(
      `${environment.apiUrl}users/answer`
    );
  }
}
